export default {
  getNow() {
    const hoy = new Date
    return `${hoy.getFullYear()}-${hoy.getMonth()<10?'0':''}${(hoy.getMonth() + 1)}-${hoy.getDate()<10?'0':''}${hoy.getDate()} ${hoy.getHours()<10?'0':''}${hoy.getHours()}:${hoy.getMinutes()<10?'0':''}${hoy.getMinutes()}:${hoy.getSeconds()<10?'0':''}${hoy.getSeconds()}`         
  },
  getNowFile() {
    const hoy = new Date
    return `${hoy.getFullYear()}${hoy.getMonth()<10?'0':''}${(hoy.getMonth() + 1)}${hoy.getDate()<10?'0':''}${hoy.getDate()}${hoy.getHours()<10?'0':''}${hoy.getHours()}${hoy.getMinutes()<10?'0':''}${hoy.getMinutes()}${hoy.getSeconds()<10?'0':''}${hoy.getSeconds()}${hoy.getMilliseconds()}`         
  }
}